import "./SessionView.css";
import React from "react";
import { showAlert, escapeHTML, camelToSpace } from "../../js/utils.js";
import * as _ from "lodash";
import { Modal, Box } from "@mui/material";
import { NavLink } from "react-router-dom";

const parseStaff = (staffArr) => {
  const normalizedStaffArr = staffArr.map((v) =>
    typeof v === "string" ? { name: v } : v
  );
  const cleanStaff = _.uniqBy(normalizedStaffArr, "name");

  const namesOnly = cleanStaff.map((v) => v.name).join(", ");

  const details = cleanStaff
    .map((v) => {
      const email = v.email ? `email: ${v.email}` : "";
      const office = v.office ? `office: ${v.office}` : "";
      const data = [email, office].filter((v) => v).join(", ");
      return `${v.name} (${data || "No details found"})`;
    })
    .join(", ");

  return { namesOnly, details };
};

class SessionView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: props.data, showModal: false };
  }

  handleClick = () => {
    this.setState({ ...this.state, showModal: true });
  };

  render() {
    const rawData = this.state.data;
    const { details, namesOnly } = parseStaff(rawData.staff);
    const isSimilarSessions = window.location.pathname === "/similar_sessions";
    const similarSessionUrl = `/similar_sessions?${new URLSearchParams({
      courseCode: rawData.courseCode,
      sessionType: rawData.type,
      staffNames: rawData.staff.map((v) => v.name).join(","),
    }).toString()}`;
    const parsedData = [
      ["Course Code", rawData.courseCode],
      ["Course Name", rawData.courseName],
      ["Type", rawData.type],
      ["Session Group", rawData.tutorialGroup],
      ["Location", rawData.location],
      ["Staff", details],
    ].map(([key, value]) => (
      <div style={{ margin: "6px" }}>
        <div
          className="SessionPopupKey"
          style={{
            color: "var(--text-color)",
            display: "inline-block",
            fontStyle: "italic",
            fontSize: "15px",
          }}
        >
          {key}:
        </div>
        <div
          style={{
            display: "inline-block",
            color: "var(--text-color)",
            fontSize: "18px",
            margin: "0 5px",
          }}
        >
          {value}
        </div>
      </div>
    ));
    const modal = (
      <Modal
        open={this.state.showModal}
        onClose={() => {
          this.setState({ ...this.state, showModal: false });
        }}
        sx={{ position: "absolute" }}
      >
        <Box
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "var(--background)",
            padding: "15px",
            textAlign: "center",
            maxWidth: "95%",
          }}
        >
          {!isSimilarSessions && (
            <NavLink to={similarSessionUrl}>
              <button
                style={{
                  background: "var(--color1)",
                  color: "var(--text-color)",
                  fontSize: "16px",
                  boxShadow: "0 0 5px 0 var(--color1)",
                  padding: "10px",
                  margin: "10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  // border: "none",
                  borderColor: "var(--color3)",
                }}
              >
                Similar Sessions
              </button>
            </NavLink>
          )}
          {parsedData}
        </Box>
      </Modal>
    );
    return (
      <>
        <div className="SessionView" onClick={this.handleClick}>
          <div
            className={["sessioncontainer", this.state.data.type].join(" ")}
            onClick={this.handleClick}
          >
            <div id="location" onClick={this.handleClick}>
              {this.state.data.location}
            </div>
            <div id="course" onClick={this.handleClick}>
              {this.state.data.courseCode}
            </div>
            <div id="group" onClick={this.handleClick}>
              {this.state.data.tutorialGroup}
            </div>
            <div id="staff" onClick={this.handleClick}>
              {namesOnly}
            </div>
          </div>
        </div>
        {modal}
      </>
    );
  }
}
export default SessionView;
